{
  "instances": {
    "quartz": {
      "actions": "Ações",
      "active_triggers": "Disparadores Ativos",
      "associated_triggers": "Disparadores Associados",
      "associated_with_calendar": "Associado ao calendário",
      "basic_information": "Informações Básicas",
      "calendar": "Calendário",
      "class": "Classe",
      "configuration": "Configuração",
      "cron_expression": "Expressão Cron",
      "custom_trigger": "Disparador Personalizado",
      "days_of_week": "Dias da Semana",
      "description": "Descrição",
      "details": "Detalhes",
      "disabled": "Desabilitado",
      "durable": "Durável",
      "enabled": "Habilitado",
      "end_time": "Hora de Término",
      "final_fire_time": "Tempo do Último Disparo Final",
      "friday": "Sexta-feira",
      "group": "Grupo",
      "infinite": "Infinito",
      "interval": "Intervalo",
      "job_data": "Dados da Tarefa",
      "job_name": "Nome da Tarefa",
      "jobs": "Tarefas",
      "key": "Chave",
      "label": "Quartz",
      "last_fire": "Último Disparo",
      "last_fire_time": "Tempo do Último Disparo",
      "monday": "Segunda-feira",
      "name": "Nome",
      "next_fire": "Próximo Disparo",
      "next_fire_time": "Próximo Tempo de Disparo",
      "no": "Não",
      "no_data": "Nenhuma informação de Quartz disponível",
      "paused_triggers": "Disparadores em Pausa",
      "preserve_hour_of_day": "Preservar Hora do Dia",
      "priority": "Prioridade",
      "recovery": "Recuperação",
      "repeat_count": "Número de Repetições",
      "request_recovery": "Solicitar Recuperação",
      "saturday": "Sábado",
      "schedule_configuration": "Configuração do Agendamento",
      "skip_day_if_hour_does_not_exist": "Pular Dia se a Hora Não Existir",
      "start_time": "Hora de Início",
      "state": "Estado",
      "sunday": "Domingo",
      "system_default": "Padrão do Sistema",
      "thursday": "Quinta-feira",
      "time_window": "Janela de Tempo",
      "time_zone": "Fuso Horário",
      "times_triggered": "Vezes Disparadas",
      "timing_information": "Informações de Tempo",
      "total": "total",
      "trigger_data": "Dados do Disparador",
      "trigger_failed": "Falha ao acionador",
      "trigger_failed_message": "Falha ao acionar o trabalho: {error}",
      "trigger_failed_notification": "Falha ao acionar o trabalho \"{jobName}\": {error}",
      "trigger_fire_times": "Tempos de Disparo",
      "trigger_job_now": "Executar Tarefa Agora",
      "trigger_success_message": "Trabalho \"{jobName}\" acionado com sucesso",
      "trigger_success_title": "Trabalho Acionado",
      "triggers": "Disparadores",
      "tuesday": "Terça-feira",
      "type": "Tipo",
      "value": "Valor",
      "wednesday": "Quarta-feira",
      "yes": "Sim"
    }
  }
}
